import React from "react";
import PropTypes from "prop-types";
import ContentHeader from "../../../molecules/components/ContentHeader";
import { RingLoader } from "react-spinners";

const CustomerList = ({
  title,
  children,
  breadcrumbs,
  loading,
  isFilterOpen,
  filterToggle,
  refresh
}) => (
  <div>
    <ContentHeader
      type={"customers"}
      title={title}
      breadCrumbs={breadcrumbs}
      filter
      isFilterOpen={isFilterOpen}
      filterToggle={filterToggle}
      toggleCategorySidebar={null}
    />
    <div className="spinner">
      <RingLoader color={"#d42e2b"} loading={loading} size={120} margin={20} />
    </div>
    <div className={loading && "invisible"}>
      <button type="button" onClick={refresh} className="loading-btn">
        Refresh {<i className="fa fa-refresh" />}
      </button>
      {children}
    </div>
  </div>
);

CustomerList.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  breadcrumbs: PropTypes.array,
  loading: PropTypes.bool,
  isFilterOpen: PropTypes.bool,
  filterToggle: PropTypes.func
};

export default CustomerList;



// WEBPACK FOOTER //
// ./src/routes/CustomerList/components/CustomerList.js